// extracted by mini-css-extract-plugin
module.exports = {"extra_list":"extra_list-1GWK6bLA"};